import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import FeatureGrid from "./components/FeatureGrid";
import MoreCategories from "./components/MoreCategories";
import AboutSection from "./components/AboutSection";
import BlogMatrix from "./components/BlogMatrix";
import CtaSection from "./components/CtaSection";
import siteUrl from "@/config/site";

export default function Home() {
  return (
    <main>
      {/* JSON-LD WebSite Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "Mulebuy Spreadsheet",
            url: siteUrl,
            description: "The most updated product spreadsheet database for smart shopping. Browse curated categories including Shoes, Hoodies, T-Shirts, Jackets, and Accessories with weekly updates.",
            potentialAction: {
              "@type": "SearchAction",
              target: siteUrl + "/search?q={search_term_string}",
              "query-input": "required name=search_term_string"
            }
          })
        }}
      />
      <Navbar />
      <HeroSection />
      <FeatureGrid />
      <MoreCategories />
      <AboutSection />
      <BlogMatrix />
      <CtaSection />
      <Footer />
    </main>
  );
}